export default "__VITE_ASSET__B_MPXQ5R__"